<template>
  <div class="row mt15 mb15 flex" :class="{ 'center-xs': currentLocationCode, 'local-center-select': !currentLocationCode }">
    <div class="select-wrapper relative">
      <select :disabled="!locations.length" name="locations_select" id="locations_select"
              :class="{ 'cl-tertiary': locations.length === 0, 'empty': !currentLocationCode, 'not-location-select': !currentLocationCode }"
              @change="switchLocation({ code: $event.target.value, forceCategoriesLoad: true })">
        <option disabled selected value v-if="!currentLocationCode" >{{ $t('Please, select location') }}</option>
        <location-item v-for="location in locations"
                       :location="location"
                       :key="location.code"
                       :selected="currentLocationCode"
        />
      </select>
      <label for="locations_select" class="select pointer select-wrapper" :class="{ 'location-label': !currentLocationCode }" />
    </div>
  </div>
</template>
<script>
import HomeLocationItem from 'theme/components/theme/blocks/Locations/HomeLocationItem'
import { mapGetters, mapActions } from 'vuex'
import i18n from '@vue-storefront/i18n'

export default {
  name: 'HomeLocationsList',
  components: {
    'location-item': HomeLocationItem
  },
  props: {
    routeSuffix: {
      type: String,
      default: () => ''
    }
  },
  computed: {
    ...mapGetters({
      locations: 'locations/getLocations',
      currentLocation: 'locations/getActiveLocation'
    }),
    currentLocationCode () {
      if (!this.currentLocation || typeof this.currentLocation === 'undefined' || typeof this.currentLocation === undefined) {
        return ''
      }

      return this.currentLocation.code
    }
  },
  methods: {
    ...mapActions({
      changeLocation: 'locations/setCurrentLocation',
      loadTags: 'partner_tags/loadTags',
      OnAndOffLoader: 'ui/OnAndOffLoader'
    }),
    async switchLocation (payload) {
      this.OnAndOffLoader(true)
      await this.changeLocation(payload)
        .catch(e => {
           console.error(e)
           this.$store.dispatch('notification/spawnNotification', {
             type: 'error',
             message: i18n.t('Something went wrong ...'),
             action1: { label: i18n.t('OK') }}
           )
        })
        .finally(() => this.OnAndOffLoader(false))

      if (this.currentLocation.layout_code === 'partners_only') {
        this.loadTags({ locationCode: payload.code })
      }
      this.$router.push(`/${payload.code}${this.routeSuffix}`)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~theme/css/variables/colors';
@import '~theme/css/helpers/functions/color';
@import '~theme/css/base/text';
$color-tertiary: color(tertiary);
$color-black: color(black);
$color-puerto-rico: color(puerto-rico);
$color-hover: color(tertiary, $colors-background);

.select-wrapper {
  select {
    @extend .h4;
    border: none;
    width: 280px;
    height: 40px;
    -moz-appearance: none;
    -webkit-appearance: none;
    border-radius: 0;
    background-color: white;
    font-size: 15px;
    cursor: pointer;

    &:hover,
    &:focus {
      outline: none;
      border-color: $color-puerto-rico;
    }

    &:disabled,
    &:disabled + label {
      opacity: 0.5;
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  label {
    color: #999;
    position: absolute;
    pointer-events: none;
    user-select: none;
    top: 0;
    left: 0;
    transition: 0.2s ease all;
    -moz-transition: 0.2s ease all;
    -webkit-transition: 0.2s ease all;
    &::after {
      content: url("../../../../assets/icons/icon-map.svg");
      width: 40px;
      height: 31px;
      background-color: #11bb2e;
      position: absolute;
      right: 0;
      top: 0;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
      text-align: center;
      padding-top: 8px;
    }
  }
  select:focus ~ label, select:not(.empty) ~ label {
    top: 0;
    font-size: 12px;
    color: $color-puerto-rico;
    display: block;
  }
}

.select {
  display: inline-block;
  width: 280px;
  height: 38px;
  line-height: 38px;
  position: relative;
  border-radius: 10px;

  .icon {
    width: 40px;
    height: 40px;
    background-color: #11bb2e;
    position: absolute;
    right: -2px;
    top: 0;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    img {
      padding-top: 8px;
    }
    .img-location{
      padding-left: 10px;
      @media (max-width: 1200px) {
        padding-left: 0;
      }
    }
  }
}
#locations_select{
  padding-left: 15px;
  border-radius: 10px;
  color: #000;
}
.local-center-select{
  justify-content: start;
  @media (max-width: 1200px) {
    justify-content: center;
  }
}
.not-location-select{
  width: 464px !important;
  height: 60px !important;
  font-size: 24px !important;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.15px;
  box-shadow: 1px 2px 7px 0 rgba(0, 0, 0, 0.13) !important;
  border: solid 1px #11bb2e !important;
  @media (max-width: 500px) {
    width: 354px !important;
  }
  @media (max-width: 400px) {
    width: 300px !important;
  }
}
.location-label{
  width: 464px ;
  height: 60px ;
  @media (max-width: 500px) {
    width: 354px;
  }
  @media (max-width: 400px) {
    width: 300px;
  }
  &::after {
    content: url("../../../../assets/icons/icon-map.svg") !important;
    width: 60px !important;
    height: 45px !important;
    background-color: #11bb2e;
    position: absolute;
    right: -2px !important;
    top: 0 !important;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    text-align: center;
    padding-top: 15px !important;
  }
}
.icon-location{
  width: 60px !important;
  height: 60px !important;
  img{
    padding-left: 20px !important;
    padding-top: 18px !important;
    @media (max-width: 1200px) {
      padding-left: 0 !important;
    }
  }
}
#locations_select{
  padding-left: 15px;
  border-radius: 10px;
}
</style>
